// import { PROTECTED_PATHS } from '../../../app/constants';
// import { errorNotifier } from '../../../components/NotificationHandler';
// import { timeout } from '../../../components/utils/timeout';
// import http, { AUTH_ROUTES } from '../../../services/api';

// export const payDue = async (payload, setIsLoading, setSuccess, navigate) => {
//   setIsLoading(true);
//   const { MY_WALLET } = PROTECTED_PATHS;
//   try {
//     setIsLoading(true);
//     const {
//       data: {
//         result: { data },
//       },
//     } = await http.post(AUTH_ROUTES.PAY_DUE, payload);

//     setSuccess(true);
//     console.log(data);
//     timeout(() => navigate(MY_WALLET));
//   } catch (error) {
//     console.log(error.response);
//     errorNotifier(error?.response?.data.errors[0].message);
//   } finally {
//     setIsLoading(false);
//   }
// };

// export const getEstateDue = async (userId, setIsLoading, setEstateDue) => {
//   setIsLoading(true);
//   try {
//     const {
//       data: {
//         result: { data },
//       },
//     } = await http.get(AUTH_ROUTES.GET_ESTATE_DUE(userId));

//     console.log(data);
//     setEstateDue(data?.estateDues);
//     setIsLoading(false);
//   } catch (error) {
//     console.log(error.response);
//     setIsLoading(false);
//   }
// };

// export const getEstateInfo = async (userId, setIsLoading, setEstateInfo) => {
//   setIsLoading(true);
//   try {
//     const {
//       data: {
//         result: { data },
//       },
//     } = await http.get(AUTH_ROUTES.GET_ESTATE_INFO(userId));

//     setEstateInfo(data);
//     setIsLoading(false);
//   } catch (error) {
//     console.log(error.response);
//     setIsLoading(false);
//   }
// };

import { PROTECTED_PATHS } from '../../../app/constants';
import { errorNotifier } from '../../../components/NotificationHandler';
import { timeout } from '../../../components/utils/timeout';
import http, { AUTH_ROUTES } from '../../../services/api';

export const initializePayment = async (
  payload,
  setIsLoading,
  setPaymentData,
  setPaymentModal
) => {
  setIsLoading(true);
  try {
    setIsLoading(true);
    const {
      data: {
        result: { data },
      },
    } = await http.post(AUTH_ROUTES.INITIALIZE_ESTATE_DUE_PAYMENT, payload);

    console.log(data, 'rrr');
    setPaymentData(data);
    setPaymentModal(true);
  } catch (error) {
    console.log(error.response);
    errorNotifier(error?.response?.data.errors[0].message);
  } finally {
    setIsLoading(false);
  }
};

export const verifyEstateDuePayment = async (payload, navigate) => {
  const { MY_WALLET } = PROTECTED_PATHS;

  try {
    const { data } = await http.post(AUTH_ROUTES.VERIFY_PAYMENT, payload);
    console.log('verif', data);

    timeout(() => navigate(MY_WALLET), 2000);
  } catch (e) {
    console.log(e.response);
  }
};

export const getEstateDue = async (userId, setIsLoading, setEstateDue) => {
  setIsLoading(true);
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_ESTATE_DUE(userId));

    setEstateDue(data?.estateDues);
    setIsLoading(false);
  } catch (error) {
    console.log(error.response);
    setIsLoading(false);
  }
};

export const getEstateInfo = async (userId, setIsLoading, setEstateInfo) => {
  setIsLoading(true);
  try {
    const {
      data: {
        result: { data },
      },
    } = await http.get(AUTH_ROUTES.GET_ESTATE_INFO(userId));

    setEstateInfo(data);
    setIsLoading(false);
  } catch (error) {
    console.log(error.response);
    setIsLoading(false);
  }
};
